
(function() {
    'use strict';
    var controllerId = 'locationCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', locationCtrl]);

    function locationCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.locations = [];
        vm.title = 'Location List View';

        vm.query = {
            queryType:'array-count',
            search:'',
            order_by:"product_id",
            order_dir:"desc",
            location_type_id: '"99"',
            page:1,
            limit:20
        };
        //console.log(vm.query);
        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        vm.query_location = {
                queryType:'count',
                search:'',
                order_by:"product_id",
                order_dir:"desc",
                limit:20,
                page:1
            };
       datacontext.get_location_products(vm.query_location).then(function (httpResult) {
            vm.location_count = httpResult.data.total;
        });

       datacontext.get_location_types({warehouse_id:$scope.warehouse_id,isActive:1}).then(function (httpResult) {
           vm.location_types = httpResult.data.data;
       });
       datacontext.get_product_categories().then(function (httpResult) {
           vm.product_categories = httpResult.data;
       });

       vm.query_backstock = {
               order_by:"location_id",
               order_dir:"desc",
               location_type_id:0,
               page:1
           };
       datacontext.get_backstockRestock(vm.query_backstock).then(function(httpResult) {
        vm.backstock_count =httpResult.data.data.length;
       });
       vm.query_empty = {
    		   queryType:'count',
               order_by:"location_id",
               order_dir:"desc",
               page:1,
               location_type_id:0,
               is_empty:1
           };
       datacontext.get_product_location(vm.query_empty).then(function (httpResult) {
    	   vm.empty_location = httpResult.data.data[0].total;
       });
       datacontext.get_product_audit_needed(vm.query_backstock).then(function (httpResult) {
           vm.audits_count = httpResult.data.data.length;
       });
       datacontext.get_common_locations().then(function (httpResult) {
        // console.log(httpResult.data);
         vm.common_location_count = httpResult.data.TOTAL;
         vm.results_com = httpResult.data;
        });

       // datacontext.get_empty_locations().then(function (httpResult) {
       //
       //     vm.empty_locations_count = httpResult.data.data;
       // });

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
          /*
          if(vm.grid !== 0){
        		vm.grid = 0;
        		return "";
        	}
          */
            vm.grid = 0;
            for ( var i in newValue ) {
                if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_location_products();
                }
            }
        });

        activate();

        function activate() {
            var promises = [get_location_products()];
            common.activateController(promises, controllerId)
                .then(function() {
                   // log('Activated Location List View');
                });
        }

        $scope.refresh_backstockRestockCtrl = function() {
            $scope.$broadcast('refresh_backstockRestockCtrl', 'refresh');
        };

        $scope.refresh_emptyLocationsCtrl = function() {
            $scope.$broadcast('refresh_emptyLocationsCtrl', 'refresh');
        };

        $scope.refresh_locationAlertsCtrl = function() {
            $scope.$broadcast('refresh_locationAlertsCtrl', 'refresh');
        };

        $scope.refresh_locationPendingAuditCtrl = function() {
            $scope.$broadcast('refresh_locationPendingAuditCtrl', 'refresh');
        };

        $scope.refresh_locationEmptyCtrl = function() {
            $scope.$broadcast('refresh_locationEmptyCtrl', 'refresh');
        };

        $scope.refresh_locationCommonCtrl = function() {
            $scope.$broadcast('refresh_locationCommonCtrl', 'refresh');
        };

        $scope.refresh_locationHistoryCtrl = function() {
            $scope.$broadcast('refresh_locationHistoryCtrl', 'refresh');
        };
        $scope.refresh_BlacklightsCtrl = function() {
            $scope.$broadcast('refresh_BlacklightsCtrl', 'refresh');
        };
        $scope.refresh_bestSellersCtrl = function() {
            $scope.$broadcast('refresh_bestSellersCtrl', 'refresh');
        };
        $scope.refresh_shelfAuditCtrl = function() {
            $scope.$broadcast('refresh_shelfAuditCtrl', 'refresh');
        };

        function get_location_products() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    vm.query.limit = 50;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_location_products(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        // set new data
                        vm.grid = 1;
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }
    }
})();
